import axios from '@/utils/axios'
import { ISO_TO_ZH_LOCALE_KEY } from '@/locales/generatedIsoToZhLocaleKey';
import store from '@/store';

export const trackLog  =  (params: object, {currentLanguage = '中文'}) => {
  let countryCode = 'be_null'
  try {
    countryCode = store.getState()?.common?.country || 'be_null';
  } catch(e) {}
  return axios.post('/api/gateway/login/intl/track/h5/new', params, {
    headers: {
      source_type: 'H5',
      country_code: countryCode,
      country: ISO_TO_ZH_LOCALE_KEY[countryCode] || 'be_null',
      timestamp: Date.now(),
    }
  });
}

